import React from 'react';
import hasHoc from 'util/hoc/has-hoc';
import { Link } from 'library/util/core-router';
import { resolve } from 'library/helpers/path-resolver';
import { Table, EditHeader, NewRecordLink } from 'apps/admin/pages/onboarding-steps/styles';

const List = ({ graph_data = {}, graph_loading, handle_graph_loading }) => {
  if (graph_loading) return handle_graph_loading();
  const steps = resolve(graph_data, 'onboarding_steps/results', []);

  const mapRows = () => {
    return steps.map((step) => (
      <tr key={step.id}>
        <td>
          <Link to={`/admin/onboarding-steps/${step.id}`}>{step.id}</Link>
        </td>

        <td>{step.set_key}</td>

        <td>{step.title}</td>

        <td>{step.target}</td>

        <td>{step.message}</td>

        <td>{JSON.stringify(step.card_config)}</td>
      </tr>
    ));
  };

  return (
    <React.Fragment>
      <NewRecordLink>
        <Link to={`/admin/onboarding-steps/new`}>New step</Link>
      </NewRecordLink>
      <Table>
        <thead>
          <EditHeader>Edit</EditHeader>

            <th>Set key</th>

            <th>Title</th>

            <th>Target</th>

            <th>Message</th>

            <th>Card config</th>

        </thead>
        <tbody>{mapRows()}</tbody>
      </Table>
    </React.Fragment>
  );
};

List.query = `{
  onboarding_steps {
    results {
      id

      set_key
      title
      target
      message
      card_config
    }
  }
}`;

List.hoc_list = ['withData'];
export default hasHoc(List);
